import { AxiosError } from 'axios';
import { call, put, take, all, fork, select } from 'redux-saga/effects';
import * as actions from '../actions';
import { apiMethods } from '../services/api';
import { apiMethodsConst } from '../services/methods';

type TApiMethodKey = keyof typeof apiMethods;

function* callAndDispatch(method: TApiMethodKey, payload?: any): Generator<any, void, any> {
  const response = yield call(apiMethods[method], payload);
  yield put({ type: method, payload: response });
}

function* callAndDispatchPayload(method: TApiMethodKey, payload?: any): Generator<any, void, any> {
  yield call(apiMethods[method], payload);
  yield put({ type: method, payload });
}

function* watchGetAllAlerts(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.GET_ALL_ALERTS_ACTION);
  while (true) {
    const { state }: { state: any } = yield take(actions.GET_ALL_ALERTS_ACTION);
    yield put({ type: events.REQUEST });
    try {
      const { searchParams }: { searchParams: any } = yield select((store: any) => store.alerts);

      if (JSON.stringify(state) && JSON.stringify(searchParams) !== JSON.stringify(state)) {
        yield put({ type: events.REQUEST, payload: state });

        yield* callAndDispatch(apiMethodsConst.GET_ALERTS_REQUEST, state);

        yield put({
          type: events.SUCCESS,
        });
      }
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchDeleteAllAlerts(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.DELETE_ALL_ALERTS_ACTION);
  while (true) {
    yield take(actions.DELETE_ALL_ALERTS_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.DELETE_ALERTS_REQUEST, undefined);

      yield put({
        type: events.SUCCESS,
      });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchDeleteOneAlert(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.DELETE_ONE_ALERT_ACTION);
  while (true) {
    const { alertId }: { alertId: any } = yield take(actions.DELETE_ONE_ALERT_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatchPayload(apiMethodsConst.DELETE_ONE_ALERT_REQUEST, alertId);

      yield put({
        type: events.SUCCESS,
      });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

// use them in parallel
export default function* sagaAlerts(): Generator<any, void, any> {
  yield all([fork(watchGetAllAlerts), fork(watchDeleteAllAlerts), fork(watchDeleteOneAlert)]);
}
